import { Icon } from '@iconify/react';
import FilterListOffIcon from '@mui/icons-material/FilterListOff';
import CryptoJS from 'crypto-js';
import { useState } from 'react';
// material
import {
  Autocomplete,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormHelperText,
  Grid,
  IconButton,
  InputAdornment,
  MenuItem,
  Select,
  TextField,
  Tooltip,
  Typography
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
// react icons
import { MdAssignmentInd, MdOutlinePermContactCalendar } from 'react-icons/md';
// material icons
import CloseIcon from '@mui/icons-material/Close';
import EmojiPeopleIcon from '@mui/icons-material/EmojiPeople';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import SettingsAccessibilityIcon from '@mui/icons-material/SettingsAccessibility';
// other icons
import searchFill from '@iconify/icons-eva/search-fill';
import add from '@iconify/icons-ic/add';
import roundFilterList from '@iconify/icons-ic/round-filter-list';
// ---------------------------------------------------------
import 'react-date-range/dist/styles.css'; // main css file
import { useDispatch } from 'react-redux';
import 'react-date-range/dist/theme/default.css'; // theme css file
import { fDate } from '../../utils/formatTime';
import { DateRangeStyled, RootStyle, SearchStyle } from '../Global/Styling';
// ----------------------------------------------------------------------
import { PARTNER_TO_OFFLINE_URL, domainUrl } from '../services/globalApi';
import useGlobalSelector from '../../store/Slice/Global/GlobalSelector';
import useLeadSelector from '../../store/Slice/Lead/LeadSelector';
// import { getRecoEngineApi } from 'src/store/Slice/Lead/LeadSlice';
import { getRecoEngineApi } from '../../store/Slice/Lead/LeadSlice';
import { LeadApi } from '../../utils/Apis';
// import useLoginSelector from 'src/store/Slice/Login/LoginSelector';
import useLoginSelector from '../../store/Slice/Login/LoginSelector';

export default function LeadsToolbar({
  filterName,
  onFilterName,
  selectProduct,
  setSelectProduct,
  onFilterProduct,
  selectStatus,
  onFilterStatus,
  selected,
  filterDatesRange,
  setFilterDatesRange,
  cityListData,
  setCityListData,
  onAssignSubmit,
  openAssign,
  setOpenAssign,
  assignValue,
  setAssignValue,
  alertMsg,
  setAlertMsg,
  setSelectSource,
  setSelectStatus,
  setFilterName,
  leadsListResponse,
  selectLeadSource,
  setSelectLeadSource,
  onFilterLeadSource
}) {
  const navigate = useNavigate();
  const [isOpenFilter, openFilter] = useState(false);
  const [openAdd, setOpenAdd] = useState(false);
  const [showTextfield, setShowTextfield] = useState(false);
  const { LoginData } = useLoginSelector();
  const dispatch = useDispatch();

  const { LoanTypeDrop, MasterTypeListDrop, InternalSaleManagerFilterDrop, CityDrop } =
    useGlobalSelector();
  const { LeadListStatusDrop } = useLeadSelector();

  // console.log('LoginData222', LoginData);

  const handleRemoveFilter = (e) => {
    setFilterDatesRange([
      {
        startDate: null,
        endDate: null,
        key: 'selection'
      }
    ]);
    setSelectProduct(' ');
    setCityListData(null);
    setSelectStatus(' ');
    setSelectSource(' ');
    setSelectLeadSource(' ');
    setFilterName('');
  };

  async function handleRecoEngineSection() {
    const userId = LoginData?.userId;
    const result = await dispatch(getRecoEngineApi({ userId }));

    // console.log('result2222', result);

    const qrUrl = result?.data?.qrUrl;

    if (!qrUrl) {
      console.error('QR URL not found');
      return;
    }

    const payload = JSON.stringify({ qrUrl, userId });

    // Step 1: Open a blank page
    const newWindow = window.open(qrUrl, '_blank', 'noopener,noreferrer');
  }

  return (
    <>
      {isOpenFilter && (
        <Box px={3} pt={2}>
          <Grid container spacing={2}>
            <Grid item xs>
              <Select
                fullWidth
                inputProps={{
                  className: `textInput customSelectBox dissabledMenu${selectProduct}`
                }}
                value={selectProduct}
                onChange={onFilterProduct}
              >
                <MenuItem value=" " disabled>
                  Select Product
                </MenuItem>
                {LoanTypeDrop?.length > 0 &&
                  LoanTypeDrop?.map((item, index) => (
                    <MenuItem value={item?.value} key={item?.value}>
                      {item?.label}
                    </MenuItem>
                  ))}
              </Select>
            </Grid>
            <Grid item xs sx={{ position: 'relative' }}>
              <Box className="displayDateRange">
                {filterDatesRange[0].startDate !== null
                  ? `${fDate(filterDatesRange[0].startDate)} to `
                  : ''}
                {filterDatesRange[0].endDate !== null ? fDate(filterDatesRange[0].endDate) : ''}
                {filterDatesRange[0].startDate === null && filterDatesRange[0].endDate === null ? (
                  <Typography className="dissabledMenu">Select Date Range</Typography>
                ) : (
                  ''
                )}
              </Box>
              <Select
                fullWidth
                inputProps={{
                  className: 'textInput'
                }}
                MenuProps={{
                  className: 'menuOpened'
                }}
                value=" "
                className="datesSelect"
              >
                <DateRangeStyled
                  editableDateInputs={false}
                  onChange={(item) => setFilterDatesRange([item.selection])}
                  moveRangeOnFirstSelection={false}
                  ranges={filterDatesRange}
                  className="dateRangePicker"
                />
              </Select>
            </Grid>
            {/* {console.log('sss CityDrop', CityDrop)} */}
            {/* {console.log('sss cityListData', cityListData)} */}
            <Grid item xs>
              <Autocomplete
                id="combo-box-demo1"
                options={CityDrop || []}
                size="small"
                value={cityListData || null}
                onChange={(e, newValue) => {
                  setCityListData(newValue);
                }}
                // compare options to value by `value` (or fallback to object/string equality)
                isOptionEqualToValue={(option, val) => {
                  const optVal = option?.value ?? option;
                  const valVal = val?.value ?? val;
                  // do strict equality (handles number/string matches too)
                  return String(optVal) === String(valVal);
                }}
                getOptionLabel={(option) => {
                  if (!option) return '';
                  if (typeof option === 'string') return option;
                  // handle both { label, value } and { cityName, ... } shapes
                  return option.label ?? option.cityName ?? '';
                }}
                renderOption={(props, option) => (
                  <li {...props}>{option?.label ?? option?.cityName ?? ''}</li>
                )}
                renderInput={(params) => (
                  <TextField {...params} fullWidth placeholder="Select City" />
                )}
              />
            </Grid>
            <Grid item xs>
              <Select
                fullWidth
                inputProps={{
                  className: `textInput customSelectBox dissabledMenu${selectStatus}`
                }}
                value={selectStatus}
                onChange={onFilterStatus}
              >
                <MenuItem value=" " disabled>
                  Select Status
                </MenuItem>
                {LeadListStatusDrop?.length > 0 &&
                  LeadListStatusDrop?.map((item, index) => (
                    <MenuItem value={item?.value} key={item?.value}>
                      {item?.label}
                    </MenuItem>
                  ))}
              </Select>
            </Grid>
            {/* do not delete this select box */}
            <Grid item xs>
              <Select
                fullWidth
                inputProps={{
                  className: `textInput customSelectBox dissabledMenu${selectLeadSource}`
                }}
                value={selectLeadSource}
                onChange={onFilterLeadSource}
              >
                <MenuItem value=" " disabled>
                  Select Lead Source
                </MenuItem>
                {MasterTypeListDrop?.length > 0 &&
                  MasterTypeListDrop?.map((item, index) => (
                    <MenuItem value={item?.value} key={item?.value}>
                      {item?.label}
                    </MenuItem>
                  ))}
              </Select>
            </Grid>
            <Grid item xs="auto">
              <Tooltip title="Reset Filter">
                <IconButton onClick={(e) => handleRemoveFilter(e)} size="small">
                  <FilterListOffIcon />
                </IconButton>
              </Tooltip>
            </Grid>
          </Grid>
        </Box>
      )}

      <RootStyle
        sx={{
          minHeight: 45,
          borderBottom: '1px solid #eaedf1'
        }}
      >
        <Box>
          {LoginData?.isReAccess === true && (
            <Tooltip title="Add new application" placement="top" arrow>
              <IconButton
                className="squareIconButton"
                // onClick={(e) => {
                //   const authToken =LoginData?.jwt;
                //   const companyId =LoginData?.companyId;
                //   const userId =LoginData?.userId;
                //   const appToken = CryptoJS.AES.encrypt('null', 'appToken').toString();
                //   const companyToken = CryptoJS.AES.encrypt(
                //     String(companyId),
                //     'companyToken'
                //   ).toString();
                //   const userToken = CryptoJS.AES.encrypt(authToken, 'userToken').toString();
                //   const leadToken = CryptoJS.AES.encrypt('null', 'leadToken').toString();
                //   const userIdToken = CryptoJS.AES.encrypt(String(userId), 'userId').toString();
                //   window.open(
                //     `${domainUrl}leads/lead-configure?u=${encodeURIComponent(
                //       userToken
                //     )}&c=${encodeURIComponent(companyToken)}&a=${encodeURIComponent(
                //       appToken
                //     )}&l=${encodeURIComponent(leadToken)}&ui=${encodeURIComponent(
                //       userIdToken
                //     )}&applicationCreationEntryPlatform=SALES`,
                //     `_blank`
                //   );
                // }}
                onClick={(e) => {
                  handleRecoEngineSection();
                }}
              >
                <Icon icon={add} width={18} />
              </IconButton>
            </Tooltip>
          )}
          &nbsp;&nbsp;&nbsp;
          <Tooltip
            title="My Appointment"
            placement="top"
            arrow
            onClick={(e) => {
              navigate(`/leads/appointment`);
              localStorage.setItem('leadList', JSON.stringify(leadsListResponse));
            }}
          >
            <IconButton className="squareIconButton">
              <MdOutlinePermContactCalendar size={18} />
            </IconButton>
          </Tooltip>
          &nbsp;&nbsp;&nbsp;
          <Tooltip
            title="Assign"
            placement="top"
            arrow
            onClick={(e) => {
              setOpenAssign(true);
              setAlertMsg(false);
              setAssignValue(' ');
            }}
          >
            <IconButton
              className="squareIconButton"
              classes={{ disabled: 'disabledBtn' }}
              disabled={selected && selected.length < 1}
            >
              <MdAssignmentInd size={18} />
            </IconButton>
          </Tooltip>
        </Box>

        <Box>
          <SearchStyle
            value={filterName}
            onChange={onFilterName}
            placeholder="Search Leads"
            classes={{
              root: 'searchHolder',
              input: 'searchInput'
            }}
            startAdornment={
              <InputAdornment position="start">
                <Box component={Icon} icon={searchFill} sx={{ color: 'text.disabled' }} />
              </InputAdornment>
            }
          />
          &nbsp;&nbsp;&nbsp;
          <Tooltip title="Filter list">
            <IconButton
              onClick={(e) => {
                if (isOpenFilter) {
                  openFilter(false);
                } else {
                  openFilter(true);
                }
              }}
            >
              <Icon icon={roundFilterList} />
            </IconButton>
          </Tooltip>
        </Box>
      </RootStyle>
      <Dialog open={openAdd} onClose={(e) => setOpenAdd(false)} fullWidth>
        <DialogTitle className="popupTitle">
          <Typography variant="h6">Select Mode of Application Submission</Typography>
          <IconButton onClick={(e) => setOpenAdd(false)} size="small">
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          <Grid
            container
            spacing={3}
            display="flex"
            justifyContent="space-between"
            textAlign="center"
            mb={2}
          >
            <Grid item xs={4}>
              <Box className="appSubmissionLinkB">
                <EmojiPeopleIcon className="appSubLinkIcon" />
                <Typography variant="subtitle1">Recommendation</Typography>
              </Box>
            </Grid>
            <Grid item xs={4}>
              <Box
                className="appSubmissionLinkB"
                onClick={(e) => {
                  const authToken = LoginData?.jwt;
                  const companyId = LoginData?.companyId;
                  const userId = LoginData?.userId;
                  const appToken = CryptoJS.AES.encrypt('null', 'appToken').toString();
                  const companyToken = CryptoJS.AES.encrypt(
                    String(companyId),
                    'companyToken'
                  ).toString();
                  const userToken = CryptoJS.AES.encrypt(authToken, 'userToken').toString();
                  const leadToken = CryptoJS.AES.encrypt('null', 'leadToken').toString();
                  const userIdToken = CryptoJS.AES.encrypt(String(userId), 'userId').toString();
                  window.open(
                    `${PARTNER_TO_OFFLINE_URL}/?u=${encodeURIComponent(
                      userToken
                    )}&c=${encodeURIComponent(companyToken)}&a=${encodeURIComponent(
                      appToken
                    )}&l=${encodeURIComponent(leadToken)}&ui=${encodeURIComponent(userIdToken)}`,
                    `_blank`
                  );
                  setOpenAdd(false);
                }}
              >
                <PeopleAltIcon className="appSubLinkIcon" />
                <Typography variant="subtitle1">Application</Typography>
              </Box>
            </Grid>
            <Grid item xs={4}>
              <Box
                className="appSubmissionLinkB"
                // onClick={(e) => {
                //   window.open(`http://manual.kalolytic.com/`, `_blank`);
                //   setOpenAdd(false);
                // }}
              >
                <SettingsAccessibilityIcon className="appSubLinkIcon" />
                <Typography variant="subtitle2">Referral</Typography>
              </Box>
            </Grid>
          </Grid>
          {showTextfield === 'true' && (
            <Box>
              <Box mb={2}>
                <TextField
                  fullWidth
                  inputProps={{
                    className: 'textInput'
                  }}
                  placeholder="Type master name..."
                />
              </Box>
              <Box>
                <TextField
                  fullWidth
                  inputProps={{
                    className: 'textInput'
                  }}
                  placeholder="Type master name..."
                />
              </Box>
            </Box>
          )}
        </DialogContent>
      </Dialog>
      <Dialog open={openAssign} fullWidth>
        <DialogTitle className="popupTitle">
          <Typography variant="h6">{selected && selected.length} Leads Selected</Typography>
          <IconButton
            onClick={(e) => {
              setOpenAssign(false);
              setAlertMsg(false);
            }}
            size="small"
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          <Select
            fullWidth
            inputProps={{
              className: `textInput customSelectBox dissabledMenu${assignValue}`
            }}
            value={assignValue}
            onChange={(e) => {
              setAlertMsg(false);
              setAssignValue(e.target.value);
            }}
          >
            <MenuItem value=" " disabled>
              Select Sales Person
            </MenuItem>
            {InternalSaleManagerFilterDrop?.length > 0 &&
              InternalSaleManagerFilterDrop?.map((item, index) => (
                <MenuItem value={item?.value} key={item?.value}>
                  {item?.label}
                </MenuItem>
              ))}
          </Select>
          {alertMsg === true && <FormHelperText error>Please select sales person</FormHelperText>}
        </DialogContent>
        <DialogActions>
          <Button onClick={onAssignSubmit} variant="contained" className="mainBtn">
            Submit
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
